import json from './sprite.js';

export default {
    handle: 'SP_SPT10-Soccer',
    label: 'es_SPT10-Soccer_234684276',
    json,
};
